import { Card, Statistic, Typography } from "antd";
import CountUp from "react-countup";

const { Text } = Typography;

const StatisticCountCard = ({ title, value, prefix, suffix, children, extra }) => (
  <Card hoverable style={{ height: 180 }} title={title} extra={extra}>
    <Statistic
    //   title={title}
      value={value}
      valueStyle={{fontSize : 40, fontWeight : "500"}}
      prefix={prefix}
      formatter={(value) => <CountUp end={value} duration={2} separator="," />}
    />
    {children && (
      <Text type="secondary" style={{ marginTop: 8, display: "block" }}>
        {children}
      </Text>
    )}
  </Card>
);

export default StatisticCountCard;
